import { useMediaQuery } from '@mui/material';

export const useIsMobile = () => useMediaQuery('@media screen and (max-width: 700px)', { noSsr: true });
export const useIsTablet = () => useMediaQuery('@media screen and (max-width: 1199px)', { noSsr: true });
